import { login, logout, getInfo, configs, admin_login, userinfo, getlinks } from '@/api/user'
import indexapi from '@/api/index'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { MessageBox, Message } from 'element-ui'

const getDefaultState = () => {
  return {
    token: localStorage.getItem('token'),
    name: localStorage.getItem('name'),
    avatar: localStorage.getItem('avatar'),
    userinfo: localStorage.getItem('userinfo'),
    config: localStorage.getItem('config')?JSON.parse(localStorage.getItem('config')):"",
    type: localStorage.getItem('type'),
    links: localStorage.getItem('links'),
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    localStorage.setItem('token', token)
  },
  SET_NAME: (state, name) => {
    state.name = name;
    localStorage.setItem('name', name)
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
    localStorage.setItem('avatar', avatar)
  },
  SET_USERINFO: (state, userinfo) => {
    state.userinfo = userinfo
    localStorage.setItem('userinfo', userinfo)
  },
  SET_TYPE: (state, type) => {
    state.type = type
    localStorage.setItem('type', type)
  },
  SET_LINKS: (state, links) => {
    state.links = links
    localStorage.setItem('links', links)
  },
  SET_CONFIG: (state, config) => {
    state.config = config
    localStorage.setItem('config',JSON.stringify(config))
  }

}

const actions = {
  config({ commit }) {
    return new Promise((resolve, reject) => {
      indexapi.config().then((res) => {
        commit('SET_CONFIG', res.data);
        console.log('config:', res.data)
        resolve(res.data)
      }).catch(error => {
        console.log('error', error)
        reject(error)
      })
    })
  },
  links({ commit }) {
    return new Promise((resolve, reject) => {
      getlinks().then(response => {
        var data = response.data;
        console.log(data)
        commit('SET_LINKS', data)
        resolve()
      }).catch(error => {
        console.log('error', error)
        reject(error)
      })
    })
  },
  userinfo({ commit }, user_id) {
    console.log('user_id', user_id)
    var type = localStorage.getItem('type');
    if (type == 1) {
      var stype = 2;
    } else if (type == 2) {
      var stype = 1;
    }
    return new Promise((resolve, reject) => {

      userinfo({ user_id: user_id, type: stype }).then(response => {

        var data = response.data;
        // Message({
        //   message: response.msg ,
        //   type: 'success',
        //   duration: 1000
        // })
        console.log(data)
        var sdata = JSON.stringify(data)
        // commit('SET_USERINFO',sdata)
        commit('SET_USERINFO', sdata)
        commit('SET_NAME', data.nickname)
        commit('SET_AVATAR', data.avatar)
        commit('SET_TOKEN', data.id)
        // commit('SET_TYPE', 2)
        // setToken(data.id)
        resolve()
      }).catch(error => {
        console.log('error', error)
        reject(error)
      })
    })
  },
  // user login
  admin_login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {

      admin_login({ username: username.trim(), password: password.trim() }).then(response => {

        var data = response.data;
        Message({
          message: response.msg,
          type: 'success',
          duration: 1000
        })
        // console.log(data)
        var sdata = JSON.stringify(data)
        // commit('SET_USERINFO',sdata)
        commit('SET_USERINFO', sdata)
        commit('SET_NAME', data.username)
        commit('SET_AVATAR', data.avatar)
        commit('SET_TOKEN', data.id)
        // commit('SET_TYPE', 1)
        // setToken(data.id)
        resolve()
      }).catch(error => {
        console.log('error', error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      var sdata = {
        user_id: state.id
      }
      // userinfo(sdata).then(response => {
      //   var data = response.data;
      //   commit('SET_USERINFO',data)
      //   resolve(data)
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      //   removeToken() // must remove  token  first
      //   resetRouter()
      //   commit('RESET_STATE')
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
      console.log('out')

      resetRouter()
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js